import { useGetUserInfoQuery } from '../services/api';
import { BookButton } from './BookButton';
import { CheckAvailabilityButton } from './CheckAvailabilityButton';
import { JoinButton } from './JoinButton';
import { UnbookButton } from './UnbookButton';
import { UnwatchButton } from './UnwatchButton';
import { WatchButton } from './WatchButton';

export function MemberActions({
  guid,
  inSession,
}: {
  guid?: string;
  inSession: boolean;
}) {
  const { data: user, } = useGetUserInfoQuery();
  if (user?.role !== 'member')
    return null;

  return (
    <>
      <CheckAvailabilityButton
        guid={guid}
      />
      <BookButton
        guid={guid}
        inSession={inSession}
      />
      <UnbookButton
        guid={guid}
        inSession={inSession}
      />
      <JoinButton
        guid={guid}
        inSession={inSession}
      />
      <UnwatchButton
        guid={guid}
      />
      <WatchButton
        guid={guid}
        inSession={inSession}
      />
    </>
  );
}
